import React from 'react'
import { withIcon } from '../../withIcon'

function SlideFirstOutlineIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
      <path d="M7.5 17.625C7.22386 17.625 7 17.4304 7 17.1902L7 6.05981C7 5.81969 7.22386 5.62503 7.5 5.62503C7.77614 5.62503 8 5.81969 8 6.05981L8 17.1902C8 17.4304 7.77614 17.625 7.5 17.625Z" fill={color}/>
      <path fillRule="evenodd" clipRule="evenodd" d="M9.18306 12.067C8.93898 11.8229 8.93898 11.4271 9.18306 11.1831L15.1831 5.18307C15.3618 5.00432 15.6306 4.95085 15.8642 5.04759C16.0977 5.14433 16.25 5.37222 16.25 5.62501L16.25 17.625C16.25 17.8778 16.0977 18.1057 15.8642 18.2024C15.6306 18.2992 15.3618 18.2457 15.1831 18.067L9.18306 12.067ZM15 16.1161L15 7.1339L10.5089 11.625L15 16.1161Z" fill={color}/>
    </svg>
  )
}

export default withIcon(SlideFirstOutlineIcon)
